import React, { useState } from "react";
import PropTypes from "prop-types";
import { FareIssueStatus } from "../../../../reducers/reports/rides/models";
import ResolvedFareIssue from "./ResolvedFareIssue";
import OpenFareIssue from "./OpenFareIssue";

const FareIssueDetails = ({ details, resolveFareIssue, authorized }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleResolveFareIssue = (data) => {
    resolveFareIssue(data).then(() => setSubmitting(false));
  };

  if (details.status === FareIssueStatus.resolved.value) {
    return <ResolvedFareIssue details={details} />;
  }

  return (
    <OpenFareIssue
      authorized={authorized}
      details={details}
      submitting={submitting}
      handleResolveFareIssue={handleResolveFareIssue}
    />
  );
};

FareIssueDetails.propTypes = {
  details: PropTypes.object.isRequired,
  resolveFareIssue: PropTypes.func.isRequired,
  authorized: PropTypes.bool.isRequired,
};

export default FareIssueDetails;
